import { render, staticRenderFns } from "./ClientCRUD.vue?vue&type=template&id=315b8614&scoped=true&"
import script from "./ClientCRUD.vue?vue&type=script&lang=js&"
export * from "./ClientCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b8614",
  null
  
)

export default component.exports